<template>
  <div>
    <v-container class="my-7">
      <banner type="top" />

      <v-row class="mt-4">
        <v-col cols="12" lg="7" class="mt-4 pr-lg-16" order="12" order-lg="0">
          <Title no-decoration>Entre em Contato</Title>

          <v-form
            @submit="onSubmit"
            :action="this.server + this.$route.fullPath"
            ref="form"
            id="form-contact"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              name="name"
              v-model="name"
              :rules="nameRules"
              label="Nome"
              required
              class="mt-4"
            ></v-text-field>

            <v-row>
              <v-col lg="6">
                <v-text-field
                  name="email"
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                  class="mt-4"
                ></v-text-field>
              </v-col>

              <v-col lg="6">
                <v-text-field
                  name="phone"
                  v-model="phone"
                  :rules="phoneRules"
                  label="Telefone"
                  required
                  v-mask="'(##) ####-####'"
                  class="mt-4"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
              name="message"
              v-model="message"
              :rules="messageRules"
              label="Mensagem"
              :counter="300"
              required
              class="mt-4"
            ></v-textarea>

            <v-checkbox
              name="policy_privacy"
              v-model="policy_privacy"
              :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
              required
              value="1"
              on-icon="fa fa-check-square"
              off-icon="far fa-square"
              class="policy-privacy mt-4"
            >
              <template v-slot:label>
                <div>
                  Eu li e concordo com a
                  <a @click="showPrivacy">Política de Privacidade</a>
                  .
                </div>
              </template>
            </v-checkbox>

            <v-btn
              color="primary"
              class="py-4 px-12 mt-4 btn-contact"
              type="submit"
              depressed
              height="42"
            >
              ENVIAR
            </v-btn>
          </v-form>
        </v-col>

        <v-col cols="12" lg="5" class="mt-4" order="0" order-lg="12">
          <Title no-decoration>Informações</Title>

          <div class="d-flex flex-column">
            <div
              v-for="({ title, link, icon }, i) in contact"
              :key="i"
              class="d-flex align-center mt-3"
            >
              <v-btn
                :href="link"
                target="_blank"
                color="secondary"
                class="mr-2"
                small
                icon
              >
                <v-icon size="18">{{ icon }}</v-icon>
              </v-btn>
              <a
                class="
                  text-body-2
                  grey--text
                  text--darken-4 text-decoration-none
                "
                :href="link"
                target="_blank"
                >{{ title }}</a
              >
            </div>
          </div>
        </v-col>
      </v-row>
      <banner type="center-2" class="mt-7" />
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import Banner from "@/components/cards/Banner.vue";
import { getSocial, getContact } from "@/config.js";
import { mask } from "vue-the-mask";
import { phoneTest } from "@/components/utils";

export default {
  data: () => ({
    loadingForm: false,
    valid: true,
    name: "",
    nameRules: [(v) => !!v || "Digite seu nome."],
    email: "",
    emailRules: [
      (v) => !!v || "Digite seu e-mail.",
      (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "Digite seu telefone.",
      (v) => phoneTest(v) || "Digite um telefone válido",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Digite sua mensagem.",
      (v) =>
        v.length <= 300 || "Sua mensagem deve conter menos que 300 caracteres",
    ],
    policy_privacy: false,
  }),
  computed: {
    informations() {
      return this.$rest(`informations`).item;
    },
    social() {
      return getSocial(this);
    },
    contact() {
      return getContact(this);
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-contact");

      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const formData = new FormData(form);
        const action = `${this.server}/rest/email/contact-us`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            } else {
              console.log("then");
            }
          })
          .catch(() => {
            console.log("error");
          })
          .finally(() => {
            this.loadingForm = false;
          });
      }

      event.preventDefault();
    },
  },
  directives: {
    mask,
  },
  components: {
    Title,
    Banner,
  },
};
</script>

<style scoped>
.btn-contact {
  font-size: 16px;
}
</style>
